import { selectDashboardLocation } from "Redux/Dashboard/slice";
import usaJson from "./usa-map-data.json";
import { useSelector } from "react-redux";
export const useMap = () => {
  const vehiclesMap = useSelector(selectDashboardLocation);

  function calculatePolygonCentroid(coordinates: number[][]): [number, number] {
    let totalArea = 0;
    let centroidX = 0;
    let centroidY = 0;

    for (let i = 0; i < coordinates.length; i++) {
      const [x0, y0] = coordinates[i];
      const [x1, y1] = coordinates[(i + 1) % coordinates.length];

      const a = x0 * y1 - x1 * y0;
      totalArea += a;
      centroidX += (x0 + x1) * a;
      centroidY += (y0 + y1) * a;
    }

    totalArea *= 0.5;
    centroidX /= 6 * totalArea;
    centroidY /= 6 * totalArea;

    return [centroidX, centroidY];
  }

  const centroids = usaJson.features.map((feature) => {
    const coordinates = feature.geometry.coordinates;
    const isNestedArray = Array.isArray(coordinates[0][0]);
    const polygonCoordinates = isNestedArray ? coordinates[0] : coordinates;

    const [lng, lat] = calculatePolygonCentroid(
      polygonCoordinates as number[][],
    );
    return { state: feature.properties.name, centroid: { lat, lng } };
  });

  const updatedVehiclesMap = vehiclesMap.states.map((vehicle) => {
    const matchingCentroid = centroids.find(
      (centroid) => centroid.state === vehicle.state,
    );

    return matchingCentroid
      ? {
          ...vehicle,
          lat: matchingCentroid.centroid.lat,
          lng: matchingCentroid.centroid.lng,
        }
      : vehicle;
  });
  const vehicleSeries = updatedVehiclesMap
    .filter((state: any) => state?.vehicles && state?.vehicles.length > 0)
    .map((state: any) => ({
      name: state?.state || "Unknown State",
      type: "scatter",
      coordinateSystem: "geo",
      data: [
        {
          name: state?.state,
          value: [state?.lng, state?.lat],
          properties: {
            count: state?.count ? state.count.toString() : "0",
            vehicles: state?.vehicles.map((vehicle: any) => vehicle.name),
          },
        },
      ],
      label: {
        show: true,
        formatter: state?.count ? state.count.toString() : "0",
        color: "black",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        padding: [2, 5, 2, 5],
        borderRadius: 100,
        fontSize: "1rem",
      },
      itemStyle: {
        show: false,
        width: 20,
        height: 20,
      },

      symbolSize: 0,
    }));

  return { vehicleSeries, vehiclesMap };
};
